import { GridOptions } from 'ag-grid-community';
import React, { ComponentType, FC } from 'react';
import { setDisplayName, wrapDisplayName } from 'recompose';

type KnownProps = Pick<GridOptions, 'rowData' | 'getRowNodeId'>;

type GetId = (row: Record<string, unknown>) => string;

export type RowsProps = {
  rows?: Record<string, unknown>[];
  isPaginated: boolean;
};

export const withRows =
  (getId?: GetId) =>
  <T extends KnownProps>(
    Component: ComponentType<T>,
  ): FC<Omit<T, keyof KnownProps> & RowsProps> => {
    const Next: FC<Omit<T, keyof KnownProps> & RowsProps> = ({
      rows,
      isPaginated,
      ...props
    }) => {
      if (isPaginated) {
        return (
          <Component
            {...(props as any)}
            rowModelType="serverSide"
            cacheBlockSize={100}
            maxConcurrentDatasourceRequests={2}
            infiniteInitialRowCount={10}
            maxBlocksInCache={3}
            rowBuffer={10}
            getRowNodeId={getId}
            blockLoadDebounceMillis={100}
            serverSideInitialRowCount={10}
            isPaginated={isPaginated}
          />
        );
      }

      return (
        <Component
          {...(props as any)}
          rowData={rows}
          getRowNodeId={getId}
          isPaginated={isPaginated}
        />
      );
    };

    return setDisplayName(wrapDisplayName(Component, 'WithRows'))(Next);
  };
